import { render, staticRenderFns } from "./CoursePreview.vue?vue&type=template&id=3743f19f&scoped=true&"
import script from "./CoursePreview.vue?vue&type=script&lang=js&"
export * from "./CoursePreview.vue?vue&type=script&lang=js&"
import style0 from "./CoursePreview.vue?vue&type=style&index=0&id=3743f19f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743f19f",
  null
  
)

export default component.exports